import React from 'react';
import styled from 'styled-components';
import { useTranslation } from '@hooks';
import { Caption2 } from '@components/styles/Typography';
import { CargoIcon, CardIcon, SecureIcon } from '@components/icons';

const ShopFeatures = () => {
    const { t } = useTranslation();
    return (
        <ShopFeaturesContainer>
            <FeatureItem>
                <IconWrapper>
                    <CargoIcon />
                </IconWrapper>
                <Caption2>{t('freeShippingTurkiye')}</Caption2>
            </FeatureItem>
            <FeatureItem>
                <IconWrapper>
                    <CardIcon />
                </IconWrapper>
                <Caption2>{t('installmentPayment')}</Caption2>
            </FeatureItem>
            <FeatureItem>
                <IconWrapper>
                    <SecureIcon />
                </IconWrapper>
                <Caption2>{t('secureShopping')}</Caption2>
            </FeatureItem>
        </ShopFeaturesContainer>
    );
};

const ShopFeaturesContainer = styled.div`
    display: none;
    padding: 0 35px;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    margin: 60px 0 70px;

    @media (max-width: 1025px) {
        display: flex;
    }
`;
const FeatureItem = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 80px;

    span {
        margin-top: 20px;
        text-align: center;
    }
`;
const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
export default ShopFeatures;
